//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PatientClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetPatientPatientQueryParameters = {
  id: number ;
}

export type EditPatientPatientQueryParameters = {
  id: number ;
}

export type GetPatientsPatientQueryParameters = {
  patientIds?: number[] | null | undefined ;
  searchQuery?: string | null | undefined ;
  subtenantIds?: number[] | null | undefined ;
  importIds?: string[] | null | undefined ;
  number?: string | null | undefined ;
  numberSource?: Types.NumberSource | null | undefined ;
  states?: Types.PatientState[] | null | undefined ;
  statuses?: Types.PatientStatus[] | null | undefined ;
  sexTypes?: Types.SexType[] | null | undefined ;
  sqlFilterQuery?: string | null | undefined ;
  lastActivityRange_StartDate?: Date | undefined ;
  lastActivityRange_EndDate?: Date | undefined ;
  lastVisitRange_StartDate?: Date | undefined ;
  lastVisitRange_EndDate?: Date | undefined ;
  tagIds?: number[] | null | undefined ;
  values?: { [key: string]: string[]; } | null | undefined ;
  includeValues?: boolean | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type RemovePatientPatientQueryParameters = {
  id: number ;
}

export type DeletePermanentlyPatientQueryParameters = {
  id: number ;
}

export type AnonymizePatientQueryParameters = {
  id: number ;
}

export type RestorePatientPatientQueryParameters = {
  id: number ;
}

export function getPatientUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patients/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientDefaultOptions: Omit<UseQueryOptions<Types.PatientDto, unknown, Types.PatientDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PatientDto, unknown, Types.PatientDto>, 'queryFn'>> = {
};
export function getGetPatientDefaultOptions() {
  return getPatientDefaultOptions;
};
export function setGetPatientDefaultOptions(options: typeof getPatientDefaultOptions) {
  getPatientDefaultOptions = options;
}

export function getPatientQueryKey(id: number): QueryKey;
export function getPatientQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetPatientPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatient',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatient',
        ...params
      ]);
  }
}
export function __getPatient(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPatient(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetPatientQuery<TSelectData = Types.PatientDto, TError = unknown>(dto: GetPatientPatientQueryParameters, options?: Omit<UseQueryOptions<Types.PatientDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a patient by id.
 * @param id The patient id.
 */
export function useGetPatientQuery<TSelectData = Types.PatientDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.PatientDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientQuery<TSelectData = Types.PatientDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetPatientPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PatientDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPatient(context, axiosConfig) : __getPatient,
    queryKey: getPatientQueryKey(id),
    ...getPatientDefaultOptions as unknown as Omit<UseQueryOptions<Types.PatientDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a patient by id.
 * @param id The patient id.
 */
export function setGetPatientData(queryClient: QueryClient, updater: (data: Types.PatientDto | undefined) => Types.PatientDto, id: number) {
  queryClient.setQueryData(getPatientQueryKey(id),
    updater
  );
}

/**
 * Gets a patient by id.
 * @param id The patient id.
 */
export function setGetPatientDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientDto | undefined) => Types.PatientDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editPatientUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patients/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editPatientMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'editPatient',
      id as any,
    ]);
}

/**
 * Edits a patient.
 * @param id The patient id.
 * @param updatedPatient Dto containing fields that needs to be changed
(all fields are optional, only fields that are present in HTTP request are changed)
 */
export function useEditPatientMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.PatientDto, unknown, Types.PatchPatientDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PatientDto, unknown, Types.PatchPatientDto, TContext> {
  const key = editPatientMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updatedPatient: Types.PatchPatientDto) => Client.editPatient(id, updatedPatient),
    mutationKey: key,
  });
}
  
type EditPatient__MutationParameters = EditPatientPatientQueryParameters & {
  updatedPatient: Types.PatchPatientDto;
}

/**
 * Edits a patient.
 * @param id The patient id.
 * @param updatedPatient Dto containing fields that needs to be changed
(all fields are optional, only fields that are present in HTTP request are changed)
 */
export function useEditPatientMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PatientDto, unknown, EditPatient__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditPatientPatientQueryParameters}): UseMutationResult<Types.PatientDto, unknown, EditPatient__MutationParameters, TContext> {
  const key = editPatientMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditPatient__MutationParameters) => Client.editPatient(data.id ?? options?.parameters?.id!, data.updatedPatient),
  mutationKey: key,
});
}
  
export function getPatientsUrl(patientIds?: number[] | null | undefined, searchQuery?: string | null | undefined, subtenantIds?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string | null | undefined, numberSource?: Types.NumberSource | null | undefined, states?: Types.PatientState[] | null | undefined, statuses?: Types.PatientStatus[] | null | undefined, sexTypes?: Types.SexType[] | null | undefined, sqlFilterQuery?: string | null | undefined, lastActivityRange_StartDate?: Date | undefined, lastActivityRange_EndDate?: Date | undefined, lastVisitRange_StartDate?: Date | undefined, lastVisitRange_EndDate?: Date | undefined, tagIds?: number[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/patients?";
if (patientIds !== undefined && patientIds !== null)
    patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
if (searchQuery !== undefined && searchQuery !== null)
    url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
if (subtenantIds !== undefined && subtenantIds !== null)
    subtenantIds && subtenantIds.forEach(item => { url_ += "SubtenantIds=" + encodeURIComponent("" + item) + "&"; });
if (importIds !== undefined && importIds !== null)
    importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
if (number !== undefined && number !== null)
    url_ += "Number=" + encodeURIComponent("" + number) + "&";
if (numberSource !== undefined && numberSource !== null)
    url_ += "NumberSource=" + encodeURIComponent("" + numberSource) + "&";
if (states !== undefined && states !== null)
    states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
if (statuses !== undefined && statuses !== null)
    statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
if (sexTypes !== undefined && sexTypes !== null)
    sexTypes && sexTypes.forEach(item => { url_ += "SexTypes=" + encodeURIComponent("" + item) + "&"; });
if (sqlFilterQuery !== undefined && sqlFilterQuery !== null)
    url_ += "SqlFilterQuery=" + encodeURIComponent("" + sqlFilterQuery) + "&";
if (lastActivityRange_StartDate === null)
    throw new Error("The parameter 'lastActivityRange_StartDate' cannot be null.");
else if (lastActivityRange_StartDate !== undefined)
    url_ += "LastActivityRange.StartDate=" + encodeURIComponent(lastActivityRange_StartDate ? "" + lastActivityRange_StartDate.toISOString() : "") + "&";
if (lastActivityRange_EndDate === null)
    throw new Error("The parameter 'lastActivityRange_EndDate' cannot be null.");
else if (lastActivityRange_EndDate !== undefined)
    url_ += "LastActivityRange.EndDate=" + encodeURIComponent(lastActivityRange_EndDate ? "" + lastActivityRange_EndDate.toISOString() : "") + "&";
if (lastVisitRange_StartDate === null)
    throw new Error("The parameter 'lastVisitRange_StartDate' cannot be null.");
else if (lastVisitRange_StartDate !== undefined)
    url_ += "LastVisitRange.StartDate=" + encodeURIComponent(lastVisitRange_StartDate ? "" + lastVisitRange_StartDate.toISOString() : "") + "&";
if (lastVisitRange_EndDate === null)
    throw new Error("The parameter 'lastVisitRange_EndDate' cannot be null.");
else if (lastVisitRange_EndDate !== undefined)
    url_ += "LastVisitRange.EndDate=" + encodeURIComponent(lastVisitRange_EndDate ? "" + lastVisitRange_EndDate.toISOString() : "") + "&";
if (tagIds !== undefined && tagIds !== null)
    tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
if (values !== undefined && values !== null)
    values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
if (includeValues === null)
    throw new Error("The parameter 'includeValues' cannot be null.");
else if (includeValues !== undefined)
    url_ += "IncludeValues=" + encodeURIComponent("" + includeValues) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientsDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfPatientListDto, unknown, Types.PageableListDtoOfPatientListDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfPatientListDto, unknown, Types.PageableListDtoOfPatientListDto>, 'queryFn'>> = {
};
export function getGetPatientsDefaultOptions() {
  return getPatientsDefaultOptions;
};
export function setGetPatientsDefaultOptions(options: typeof getPatientsDefaultOptions) {
  getPatientsDefaultOptions = options;
}

export function getPatientsQueryKey(dto: GetPatientsPatientQueryParameters): QueryKey;
export function getPatientsQueryKey(patientIds?: number[] | null | undefined, searchQuery?: string | null | undefined, subtenantIds?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string | null | undefined, numberSource?: Types.NumberSource | null | undefined, states?: Types.PatientState[] | null | undefined, statuses?: Types.PatientStatus[] | null | undefined, sexTypes?: Types.SexType[] | null | undefined, sqlFilterQuery?: string | null | undefined, lastActivityRange_StartDate?: Date | undefined, lastActivityRange_EndDate?: Date | undefined, lastVisitRange_StartDate?: Date | undefined, lastVisitRange_EndDate?: Date | undefined, tagIds?: number[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getPatientsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientIds, searchQuery, subtenantIds, importIds, number, numberSource, states, statuses, sexTypes, sqlFilterQuery, lastActivityRange_StartDate, lastActivityRange_EndDate, lastVisitRange_StartDate, lastVisitRange_EndDate, tagIds, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetPatientsPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatients',
        patientIds as any,
        searchQuery as any,
        subtenantIds as any,
        importIds as any,
        number as any,
        numberSource as any,
        states as any,
        statuses as any,
        sexTypes as any,
        sqlFilterQuery as any,
        lastActivityRange_StartDate as any,
        lastActivityRange_EndDate as any,
        lastVisitRange_StartDate as any,
        lastVisitRange_EndDate as any,
        tagIds as any,
        values as any,
        includeValues as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatients',
        ...params
      ]);
  }
}
export function __getPatients(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPatients(
      context.queryKey[2] as number[] | null | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as number[] | null | undefined,       context.queryKey[5] as string[] | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.NumberSource | null | undefined,       context.queryKey[8] as Types.PatientState[] | null | undefined,       context.queryKey[9] as Types.PatientStatus[] | null | undefined,       context.queryKey[10] as Types.SexType[] | null | undefined,       context.queryKey[11] as string | null | undefined,       context.queryKey[12] as Date | undefined,       context.queryKey[13] as Date | undefined,       context.queryKey[14] as Date | undefined,       context.queryKey[15] as Date | undefined,       context.queryKey[16] as number[] | null | undefined,       context.queryKey[17] as { [key: string]: string[]; } | null | undefined,       context.queryKey[18] as boolean | undefined,       context.queryKey[19] as number | undefined,       context.queryKey[20] as number | undefined,       context.queryKey[21] as string | null | undefined,       context.queryKey[22] as Types.SortDirection | undefined,       context.queryKey[23] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetPatientsQuery<TSelectData = Types.PageableListDtoOfPatientListDto, TError = unknown>(dto: GetPatientsPatientQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfPatientListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all patients.
 * @param patientIds (optional) 
 * @param searchQuery (optional) 
 * @param subtenantIds (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param numberSource (optional) 
 * @param states (optional) 
 * @param statuses (optional) 
 * @param sexTypes (optional) 
 * @param sqlFilterQuery (optional) 
 * @param lastActivityRange_StartDate (optional) 
 * @param lastActivityRange_EndDate (optional) 
 * @param lastVisitRange_StartDate (optional) 
 * @param lastVisitRange_EndDate (optional) 
 * @param tagIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetPatientsQuery<TSelectData = Types.PageableListDtoOfPatientListDto, TError = unknown>(patientIds?: number[] | null | undefined, searchQuery?: string | null | undefined, subtenantIds?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string | null | undefined, numberSource?: Types.NumberSource | null | undefined, states?: Types.PatientState[] | null | undefined, statuses?: Types.PatientStatus[] | null | undefined, sexTypes?: Types.SexType[] | null | undefined, sqlFilterQuery?: string | null | undefined, lastActivityRange_StartDate?: Date | undefined, lastActivityRange_EndDate?: Date | undefined, lastVisitRange_StartDate?: Date | undefined, lastVisitRange_EndDate?: Date | undefined, tagIds?: number[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfPatientListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientsQuery<TSelectData = Types.PageableListDtoOfPatientListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfPatientListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let patientIds: any = undefined;
  let searchQuery: any = undefined;
  let subtenantIds: any = undefined;
  let importIds: any = undefined;
  let number: any = undefined;
  let numberSource: any = undefined;
  let states: any = undefined;
  let statuses: any = undefined;
  let sexTypes: any = undefined;
  let sqlFilterQuery: any = undefined;
  let lastActivityRange_StartDate: any = undefined;
  let lastActivityRange_EndDate: any = undefined;
  let lastVisitRange_StartDate: any = undefined;
  let lastVisitRange_EndDate: any = undefined;
  let tagIds: any = undefined;
  let values: any = undefined;
  let includeValues: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientIds, searchQuery, subtenantIds, importIds, number, numberSource, states, statuses, sexTypes, sqlFilterQuery, lastActivityRange_StartDate, lastActivityRange_EndDate, lastVisitRange_StartDate, lastVisitRange_EndDate, tagIds, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetPatientsPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientIds, searchQuery, subtenantIds, importIds, number, numberSource, states, statuses, sexTypes, sqlFilterQuery, lastActivityRange_StartDate, lastActivityRange_EndDate, lastVisitRange_StartDate, lastVisitRange_EndDate, tagIds, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfPatientListDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPatients(context, axiosConfig) : __getPatients,
    queryKey: getPatientsQueryKey(patientIds, searchQuery, subtenantIds, importIds, number, numberSource, states, statuses, sexTypes, sqlFilterQuery, lastActivityRange_StartDate, lastActivityRange_EndDate, lastVisitRange_StartDate, lastVisitRange_EndDate, tagIds, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getPatientsDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfPatientListDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all patients.
 * @param patientIds (optional) 
 * @param searchQuery (optional) 
 * @param subtenantIds (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param numberSource (optional) 
 * @param states (optional) 
 * @param statuses (optional) 
 * @param sexTypes (optional) 
 * @param sqlFilterQuery (optional) 
 * @param lastActivityRange_StartDate (optional) 
 * @param lastActivityRange_EndDate (optional) 
 * @param lastVisitRange_StartDate (optional) 
 * @param lastVisitRange_EndDate (optional) 
 * @param tagIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetPatientsData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfPatientListDto | undefined) => Types.PageableListDtoOfPatientListDto, patientIds?: number[] | null | undefined, searchQuery?: string | null | undefined, subtenantIds?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string | null | undefined, numberSource?: Types.NumberSource | null | undefined, states?: Types.PatientState[] | null | undefined, statuses?: Types.PatientStatus[] | null | undefined, sexTypes?: Types.SexType[] | null | undefined, sqlFilterQuery?: string | null | undefined, lastActivityRange_StartDate?: Date | undefined, lastActivityRange_EndDate?: Date | undefined, lastVisitRange_StartDate?: Date | undefined, lastVisitRange_EndDate?: Date | undefined, tagIds?: number[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getPatientsQueryKey(patientIds, searchQuery, subtenantIds, importIds, number, numberSource, states, statuses, sexTypes, sqlFilterQuery, lastActivityRange_StartDate, lastActivityRange_EndDate, lastVisitRange_StartDate, lastVisitRange_EndDate, tagIds, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Gets all patients.
 * @param patientIds (optional) 
 * @param searchQuery (optional) 
 * @param subtenantIds (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param numberSource (optional) 
 * @param states (optional) 
 * @param statuses (optional) 
 * @param sexTypes (optional) 
 * @param sqlFilterQuery (optional) 
 * @param lastActivityRange_StartDate (optional) 
 * @param lastActivityRange_EndDate (optional) 
 * @param lastVisitRange_StartDate (optional) 
 * @param lastVisitRange_EndDate (optional) 
 * @param tagIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetPatientsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfPatientListDto | undefined) => Types.PageableListDtoOfPatientListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createPatientUrl(): string {
  let url_ = getBaseUrl() + "/api/patients";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createPatientMutationKey(): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'createPatient',
    ]);
}

/**
 * Creates a patient.
 * @param newPatient Request parameter
 */
export function useCreatePatientMutation<TContext>(options?: Omit<UseMutationOptions<Types.PatientDto, unknown, Types.CreatePatientDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PatientDto, unknown, Types.CreatePatientDto, TContext> {
  const key = createPatientMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (newPatient: Types.CreatePatientDto) => Client.createPatient(newPatient),
    mutationKey: key,
  });
}
  
export function removePatientUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/delete";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removePatientMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'removePatient',
      id as any,
    ]);
}

/**
 * Removes a patient.
 * @param id The patient id.
 * @param removePatientDto Deletion params
 */
export function useRemovePatientMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.RemovePatientDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.RemovePatientDto, TContext> {
  const key = removePatientMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (removePatientDto: Types.RemovePatientDto) => Client.removePatient(id, removePatientDto),
    mutationKey: key,
  });
}
  
type RemovePatient__MutationParameters = RemovePatientPatientQueryParameters & {
  removePatientDto: Types.RemovePatientDto;
}

/**
 * Removes a patient.
 * @param id The patient id.
 * @param removePatientDto Deletion params
 */
export function useRemovePatientMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemovePatient__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemovePatientPatientQueryParameters}): UseMutationResult<void, unknown, RemovePatient__MutationParameters, TContext> {
  const key = removePatientMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemovePatient__MutationParameters) => Client.removePatient(data.id ?? options?.parameters?.id!, data.removePatientDto),
  mutationKey: key,
});
}
  
export function deletePermanentlyUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/delete-permanently";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deletePermanentlyMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'deletePermanently',
      id as any,
    ]);
}

/**
 * Removes all patient data.
 * @param id The patient id.
 */
export function useDeletePermanentlyMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deletePermanentlyMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deletePermanently(id),
    mutationKey: key,
  });
}
  
type DeletePermanently__MutationParameters = DeletePermanentlyPatientQueryParameters

/**
 * Removes all patient data.
 * @param id The patient id.
 */
export function useDeletePermanentlyMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeletePermanently__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeletePermanentlyPatientQueryParameters}): UseMutationResult<void, unknown, DeletePermanently__MutationParameters, TContext> {
  const key = deletePermanentlyMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeletePermanently__MutationParameters) => Client.deletePermanently(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function anonymizeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/anonymize";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function anonymizeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'anonymize',
      id as any,
    ]);
}

/**
 * Anonymizes a patient.
 * @param id The patient id.
 * @param removePatientDto Deletion params
 */
export function useAnonymizeMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.RemovePatientDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.RemovePatientDto, TContext> {
  const key = anonymizeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (removePatientDto: Types.RemovePatientDto) => Client.anonymize(id, removePatientDto),
    mutationKey: key,
  });
}
  
type Anonymize__MutationParameters = AnonymizePatientQueryParameters & {
  removePatientDto: Types.RemovePatientDto;
}

/**
 * Anonymizes a patient.
 * @param id The patient id.
 * @param removePatientDto Deletion params
 */
export function useAnonymizeMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Anonymize__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: AnonymizePatientQueryParameters}): UseMutationResult<void, unknown, Anonymize__MutationParameters, TContext> {
  const key = anonymizeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Anonymize__MutationParameters) => Client.anonymize(data.id ?? options?.parameters?.id!, data.removePatientDto),
  mutationKey: key,
});
}
  
export function restorePatientUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/restore";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function restorePatientMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'restorePatient',
      id as any,
    ]);
}

/**
 * Restores patient.
 * @param id The patient id.
 */
export function useRestorePatientMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = restorePatientMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.restorePatient(id),
    mutationKey: key,
  });
}
  
type RestorePatient__MutationParameters = RestorePatientPatientQueryParameters

/**
 * Restores patient.
 * @param id The patient id.
 */
export function useRestorePatientMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RestorePatient__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RestorePatientPatientQueryParameters}): UseMutationResult<void, unknown, RestorePatient__MutationParameters, TContext> {
  const key = restorePatientMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RestorePatient__MutationParameters) => Client.restorePatient(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function mergePatientsUrl(): string {
  let url_ = getBaseUrl() + "/api/patients/merge";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function mergePatientsMutationKey(): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'mergePatients',
    ]);
}

/**
 * Merge patients.
 * @param dto The merge params.
 */
export function useMergePatientsMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.MergePatientsDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.MergePatientsDto, TContext> {
  const key = mergePatientsMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.MergePatientsDto) => Client.mergePatients(dto),
    mutationKey: key,
  });
}